// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DashboardContent-base__hZUGt{display:flex;flex-direction:column;gap:var(--size-5);width:100%;height:100%;padding:1rem;overflow-y:auto}.DashboardContent-skeletonGrid__ZYmFQ{display:grid;grid-template-columns:repeat(auto-fill, minmax(min(400px, 100%), 1fr));grid-gap:var(--size-4);gap:var(--size-4)}.DashboardContent-skeletonCard__yhRzc{min-height:200px;padding:var(--size-5);background:var(--surface-secondary);border-radius:var(--border-radius-2);outline:var(--size-0_25) solid var(--gray-a5);outline-offset:calc(var(--size-0_25)*-1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "DashboardContent-base__hZUGt",
	"skeletonGrid": "DashboardContent-skeletonGrid__ZYmFQ",
	"skeletonCard": "DashboardContent-skeletonCard__yhRzc"
};
export default ___CSS_LOADER_EXPORT___;
